module.exports = __webpack_public_path__ + "pc-static/img/nina.823c122.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nina.jpg
// module id = 1aqU
// module chunks = 1